/* Nestwell theme — interactions (vanilla JS, no dependencies) */
(function () {
  'use strict';
  var theme = window.theme || {};
  var qs = function (s, c) { return (c || document).querySelector(s); };
  var qsa = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || theme.moneyFormat || '${{amount}}';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function fd(n, p, t, d) {
      t = t || ','; d = d || '.';
      if (isNaN(n) || n == null) return '0';
      var s = (n / 100).toFixed(p).split('.');
      return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (s[1] ? d + s[1] : '');
    }
    var m = fmt.match(re); if (!m) return fmt;
    var v;
    switch (m[1]) {
      case 'amount_no_decimals': v = fd(cents, 0); break;
      case 'amount_with_comma_separator': v = fd(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fd(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fd(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = fd(cents, 2, ' ', ','); break;
      default: v = fd(cents, 2);
    }
    return fmt.replace(re, v);
  }
  theme.formatMoney = formatMoney;

  /* ---------- drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var f = qs('.drawer__panel [data-drawer-close]', d); if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    if (!qs('.drawer.is-open')) document.body.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  }
  theme.openDrawer = openDrawer;

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-drawer-open]');
    if (o) {
      if (o.getAttribute('data-drawer-open') === 'CartDrawer' && theme.cartType !== 'drawer') return;
      e.preventDefault(); openDrawer(o.getAttribute('data-drawer-open')); return;
    }
    var c = e.target.closest('[data-drawer-close]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') qsa('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- cart ---------- */
  function sectionsUrl(ids) {
    var root = (theme.routes && theme.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + '?sections=' + ids;
  }
  function refreshCart() {
    return fetch(sectionsUrl('cart-drawer,cross-sell-popup'), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var popupHtml = data && data['cross-sell-popup'];
        if (popupHtml) {
          var popupDoc = new DOMParser().parseFromString(popupHtml, 'text/html');
          var popupFresh = qs('#CrossSellPopupContent', popupDoc), popupCurrent = qs('#CrossSellPopupContent');
          if (popupFresh && popupCurrent) popupCurrent.innerHTML = popupFresh.innerHTML;
        }
        var html = data && data['cart-drawer']; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = qs('#CartDrawerInner', doc), cur = qs('#CartDrawerInner');
        if (fresh && cur) {
          cur.innerHTML = fresh.innerHTML;
          var count = parseInt(fresh.getAttribute('data-count') || '0', 10);
          qsa('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
        }
      });
  }
  theme.refreshCart = refreshCart;

  function changeLine(line, quantity) {
    var inner = qs('#CartDrawerInner'); if (inner) inner.style.opacity = '.5';
    return fetch(theme.routes.cart_change_url + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message); }); })
      .catch(function (err) { alert(err.message); })
      .then(function () { return theme.refreshCart(); })
      .then(function () { var i = qs('#CartDrawerInner'); if (i) i.style.opacity = ''; });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = qs('[type=submit]', form), err = qs('[data-form-error]', form), addedItem;
    // A submit button outside the form (form= attribute, e.g. the sticky bar) is the one to return focus to.
    var submitter = e.submitter || btn, outside = submitter && !form.contains(submitter);
    if (btn && btn.getAttribute('aria-busy') === 'true') return;
    if (btn) { btn.setAttribute('aria-busy', 'true'); }
    if (err) err.hidden = true;
    fetch(theme.routes.cart_add_url + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Error'); addedItem = j; });
    }).then(function () { return theme.refreshCart(); }).then(function () {
      if (theme.openCrossSell && theme.openCrossSell(addedItem, submitter)) return;
      if (theme.cartType === 'drawer') openDrawer('CartDrawer');
      else window.location.assign(theme.routes.cart_url);
    })
      .catch(function (x) {
        if (err) {
          err.textContent = x.message; err.hidden = false;
          // The error sits under the in-form button; bring it into view when the submit came from outside the form.
          if (outside) { err.scrollIntoView({ block: 'center' }); if (btn) btn.focus({ preventScroll: true }); }
        } else { alert(x.message); }
      })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); changeLine(parseInt(rm.getAttribute('data-line-remove'), 10), 0); return; }
    var b = e.target.closest('[data-qty-change]'); if (!b) return;
    e.preventDefault();
    var wrap = b.closest('.qty'), input = qs('input', wrap);
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-qty-change'), 10));
    input.value = next;
    var line = b.closest('[data-line]');
    if (line && line.closest('#CartDrawer')) { changeLine(parseInt(line.getAttribute('data-line'), 10), next); return; }
    var auto = b.closest('form[data-autosubmit]'); if (auto) auto.submit();
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('#CartDrawer [data-line] .qty input');
    if (input) changeLine(parseInt(input.closest('[data-line]').getAttribute('data-line'), 10), parseInt(input.value, 10) || 0);
  });

  /* ---------- cart drawer add-ons ("一緒に揃えたい、おすすめ商品") ---------- */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('select[data-cart-upsell-variant]'); if (!select) return;
    var item = select.closest('[data-cart-upsell]');
    var cents = parseInt(select.selectedOptions[0].getAttribute('data-price'), 10);
    var percent = parseInt(item.getAttribute('data-discount-percent'), 10) || 0;
    qs('s', qs('.cart-upsell__price', item)).textContent = formatMoney(cents);
    qs('[data-cart-upsell-price]', item).textContent = formatMoney(cents - Math.floor(cents * percent / 100));
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-upsell-add]'); if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    var item = btn.closest('[data-cart-upsell]'), variant = qs('[data-cart-upsell-variant]', item);
    var err = qs('[data-cart-upsell-error]'); if (err) err.hidden = true;
    btn.setAttribute('aria-busy', 'true');
    var inner = qs('#CartDrawerInner'); if (inner) inner.style.opacity = '.5';
    fetch(theme.routes.cart_add_url + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variant.value, 10), quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message); }); })
      .then(function () { return theme.refreshCart(); })
      .catch(function (x) { var live = qs('[data-cart-upsell-error]'); if (live) { live.textContent = x.message; live.hidden = false; } btn.removeAttribute('aria-busy'); })
      .then(function () { var i = qs('#CartDrawerInner'); if (i) i.style.opacity = ''; });
  });

  /* ---------- variant picker ---------- */
  function priceHtml(v) {
    if (v.compare_at_price && v.compare_at_price > v.price) {
      var pct = Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price);
      return '<span class="price__sale">' + formatMoney(v.price) + '</span><s class="price__compare">' + formatMoney(v.compare_at_price) + '</s><span class="price__save">' + (theme.strings.save || '-[p]%').replace('[p]', pct) + '</span>';
    }
    return '<span>' + formatMoney(v.price) + '</span>';
  }
  function initProduct(root) {
    var json = qs('[data-variant-json]', root), picker = qs('[data-variant-picker]', root);
    var gallery = qs('[data-gallery]', root);
    if (gallery) initGallery(root, gallery);
    if (!json || !picker) return;
    var variants = JSON.parse(json.textContent);
    var form = qs('form[data-product-form]', root);
    var idInput = form && qs('input[name=id]', form);
    function variantSlide(v) {
      var cover = root.hasAttribute('data-color-cover-gallery') && qsa('[data-cover-color]', gallery).filter(function (slide) { return slide.getAttribute('data-cover-color') === v.option2; })[0];
      return cover || (v.featured_media && qs('[data-media-id="' + v.featured_media.id + '"]', gallery));
    }
    function update(init) {
      var fieldsets = qsa('fieldset', picker);
      var selected = fieldsets.map(function (fs) { var c = qs('input:checked', fs); return c ? c.value : null; });
      fieldsets.forEach(function (fs, i) {
        qsa('input', fs).forEach(function (inp) {
          var ok = variants.some(function (v) {
            return v.available && v.options[i] === inp.value && v.options.every(function (o, j) { return j === i || o === selected[j]; });
          });
          inp.closest('.chip').classList.toggle('is-unavailable', !ok);
        });
        var lbl = qs('[data-selected-value]', fs); if (lbl) lbl.textContent = selected[i] || '';
      });
      var v = variants.filter(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); })[0];
      if (init) {
        if (v && gallery && root.hasAttribute('data-color-cover-gallery')) {
          var initialSlide = variantSlide(v);
          if (initialSlide) gallery.scrollTo({ left: initialSlide.offsetLeft - gallery.offsetLeft, behavior: 'instant' });
        }
        return;
      }
      var btn = qs('[data-add-button]', root), txt = qs('[data-add-text]', root), price = qs('[data-price]', root);
      if (!v) { if (btn) btn.disabled = true; if (txt) txt.textContent = theme.strings.unavailable; return; }
      if (idInput) idInput.value = v.id;
      if (price) price.innerHTML = priceHtml(v);
      if (btn) btn.disabled = !v.available;
      if (txt) txt.textContent = v.available ? theme.strings.addToCart : theme.strings.soldOut;
      if (gallery) {
        var slide = variantSlide(v);
        if (slide) gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      }
      if (root.hasAttribute('data-update-url')) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }
    picker.addEventListener('change', function () { update(false); });
    update(true);
  }
  function initGallery(root, gallery) {
    var thumbs = qsa('[data-thumb]', root);
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var slide = gallery.children[parseInt(t.getAttribute('data-thumb'), 10)];
        if (slide) gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      });
    });
    var tick;
    gallery.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(function () {
        // Nearest slide by position, so the column gap does not shift the active thumbnail on long galleries.
        var idx = 0, best = Infinity;
        Array.prototype.forEach.call(gallery.children, function (s, i) {
          var d = Math.abs(s.offsetLeft - gallery.offsetLeft - gallery.scrollLeft);
          if (d < best) { best = d; idx = i; }
        });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      }, 60);
    });
  }

  /* ---------- scrollers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-scroll]'); if (!b) return;
    var el = document.getElementById(b.getAttribute('data-target')); if (!el) return;
    el.scrollBy({ left: (b.getAttribute('data-scroll') === 'next' ? 1 : -1) * el.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ---------- reviews ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-review-toggle]');
    if (t) {
      var r = t.closest('.review'); var open = r.classList.toggle('is-open');
      t.textContent = open ? t.getAttribute('data-less') : t.getAttribute('data-more'); return;
    }
    var m = e.target.closest('[data-load-more]');
    if (m) {
      var wrap = document.getElementById(m.getAttribute('data-load-more'));
      qsa('.review[hidden]', wrap).slice(0, 6).forEach(function (r) { r.hidden = false; });
      if (!qs('.review[hidden]', wrap)) m.hidden = true;
    }
  });
  function markClamped() {
    qsa('.review__text').forEach(function (p) {
      var btn = p.parentNode.querySelector('[data-review-toggle]');
      if (btn) btn.hidden = p.scrollHeight <= p.clientHeight + 2;
    });
  }

  /* ---------- announcement rotator ---------- */
  function initRotator(el) {
    var msgs = qsa('.announcement__msg', el); if (msgs.length < 2) return;
    var i = 0, ms = (parseInt(el.getAttribute('data-interval'), 10) || 5) * 1000;
    setInterval(function () {
      msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active');
    }, ms);
  }

  /* ---------- countdown ---------- */
  function initCountdown(el) {
    var end = new Date(el.getAttribute('data-countdown')).getTime(); if (isNaN(end)) return;
    var parts = qsa('[data-cd]', el);
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var d = Math.max(0, end - Date.now());
      if (d === 0) { el.hidden = true; return; }
      var v = { d: Math.floor(d / 864e5), h: Math.floor(d / 36e5) % 24, m: Math.floor(d / 6e4) % 60, s: Math.floor(d / 1e3) % 60 };
      parts.forEach(function (p) { var k = p.getAttribute('data-cd'); p.textContent = k === 'd' ? v.d : pad(v[k]); });
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- collection ---------- */
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-sort-select]');
    if (s) { var u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); window.location.href = u.toString(); return; }
    var f = e.target.closest('form[data-filter-form]');
    if (f && e.target.type === 'checkbox') f.submit();
  });

  /* ---------- recommendations ---------- */
  function initRecos(el) {
    if (qs('.grid', el) || !el.getAttribute('data-url')) return;
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (t) {
      var doc = new DOMParser().parseFromString(t, 'text/html');
      var fresh = qs('[data-recos]', doc); if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }

  /* ---------- header ---------- */
  function initHeader() {
    var h = qs('[data-header]'); if (!h) return;
    var on = false;
    window.addEventListener('scroll', function () {
      var s = window.scrollY > 8; if (s !== on) { on = s; h.classList.toggle('is-scrolled', s); }
    }, { passive: true });
  }

  function init(scope) {
    qsa('[data-product-root]', scope).forEach(initProduct);
    qsa('[data-rotator]', scope).forEach(initRotator);
    qsa('[data-recos]', scope).forEach(initRecos);
    qsa('[data-countdown]', scope).forEach(initCountdown);
    markClamped();
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); initHeader(); });
  window.addEventListener('load', markClamped);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();


